'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.directive('otppInflationModule', function() {
  return {
    restrict: 'E',
    templateUrl: 'scripts/directives/otpp-pension-modules/inflation-module.prt.html',
    link: function(scope) {
      if (!scope.attributes.inflationDataAvailable) {
        scope.noInflationData = true;
      } else if (!scope.attributes.inceptedBeforeJan) {
        scope.newPensioner = true;
      } else {
        scope.hasInflation = true;
      }
    }
  };
});
